import { StyledArrowButton } from '@/components/styles'
import Icon from '@/assets/icons'

export default function ArrowButton() {
  return (
    <StyledArrowButton>
      <Icon name="arrow-left" />
    </StyledArrowButton>
  )
}
